<script setup lang="ts">
  import { COOKIE_OPTIONS } from '@/utils/constants/cookies'

  // Temp fix to the hydration mismatch issue with SSR on Vue 3.4
  // (radix component ID's not matching between server and client)
  // This should be resolved in Vue 3.5, when it comes out
  const useIdFn = () => useId().replace(/[-:]/, '_')

  const {
    public: { gtmNew, gtmOld, env }
  } = useRuntimeConfig()

  const gdprCookies = useCookie<string>('gdpr_settings', COOKIE_OPTIONS)

  if (gdprCookies.value?.includes('web')) {
    const src =
      env === 'production'
        ? 'https://cdn.optimizely.com/js/28373680651.js'
        : 'https://cdn.optimizely.com/js/28851540020.js'

    useHead({
      link: [{ rel: 'dns-prefetch', href: 'https://cdn.optimizely.com' }],
      script: [
        {
          src: src,
          tagPriority: 'after:script:consent'
        }
      ]
    })
  }
</script>

<template>
  <ConfigProvider :use-id="useIdFn">
    <NuxtLayout>
      <MainWrapper>
        <NuxtPage />
      </MainWrapper>
    </NuxtLayout>
  </ConfigProvider>
  <ClientOnly>
    <noscript
      v-if="gtmNew"
      data-cookieconsent="ignore"
    >
      <iframe
        :src="`https://www.googletagmanager.com/ns.html?id=${gtmNew}`"
        height="0"
        width="0"
        style="display: none; visibility: hidden"
      ></iframe>
    </noscript>
    <noscript
      v-if="gtmOld"
      data-cookieconsent="ignore"
    >
      <iframe
        :src="`https://www.googletagmanager.com/ns.html?id=${gtmOld}`"
        height="0"
        width="0"
        style="display: none; visibility: hidden"
      ></iframe>
    </noscript>
  </ClientOnly>
</template>
